import { Pipe, PipeTransform } from '@angular/core';
import {
  CARER_ROLE,
  COORDINATOR_ROLE,
  CUSTOMER_FAMILY_REPRESENTATIVE_ROLE,
  CUSTOMER_FAMILY_ROLE,
  CUSTOMER_MEMBER_ROLE,
  CUSTOMER_SELF_ROLE,
  ORGANISATION_ADMIN_ROLE,
} from '@careapp-group/core';

/**
 * Selects the best/highest ranking role to display with the user from a list of roles.
 */
@Pipe({ name: 'bestrole', pure: true })
export class BestRolePipe implements PipeTransform {
  transform(roles: Array<any>): any {
    if (!Array.isArray(roles)) {
      return roles;
    }
    if (roles.length === 0) {
      return '';
    }
    let roleNames: Array<string>;
    if (typeof roles[0] !== 'string') {
      roleNames = roles.map((role) => role.role);
    } else {
      roleNames = roles;
    }
    if (roleNames.includes(ORGANISATION_ADMIN_ROLE)) {
      return ORGANISATION_ADMIN_ROLE;
    }
    if (roleNames.includes(COORDINATOR_ROLE)) {
      return COORDINATOR_ROLE;
    }
    if (roleNames.includes(CARER_ROLE)) {
      return CARER_ROLE;
    }
    if (roleNames.includes(CUSTOMER_SELF_ROLE) || roleNames.includes(CUSTOMER_MEMBER_ROLE)) {
      return CUSTOMER_SELF_ROLE;
    }
    if (roleNames.includes(CUSTOMER_FAMILY_REPRESENTATIVE_ROLE)) {
      return CUSTOMER_FAMILY_REPRESENTATIVE_ROLE;
    }
    if (roleNames.includes(CUSTOMER_FAMILY_ROLE)) {
      return CUSTOMER_FAMILY_ROLE;
    }
    return roleNames[0];
  }
}
